// extracted by mini-css-extract-plugin
export default {"root":"dkVitm","mobile":"xGfefq","disablePadding":"j55_gt","disableGutters":"vTl85f","centered":"FQ_Yqn"};